import React, { ReactNode, useCallback, useEffect, useState } from 'react';

import ViewportContext from './ViewportContext';
import { Breakpoints, Viewport } from './ViewportDefinition';

interface ViewportProps {
  children: ReactNode;
  reqViewport?: Viewport;
}

const getDeviceConfig = (width: number): Viewport => {
  if (width < Breakpoints.SMALL_MOBILE) {
    return Viewport.SMALL_MOBILE;
  } else if (width < Breakpoints.MOBILE) {
    return Viewport.MOBILE;
  } else if (width < Breakpoints.TABLET) {
    return Viewport.TABLET;
  } else if (width < Breakpoints.DESKTOP) {
    return Viewport.DESKTOP;
  }

  return Viewport.WIDE;
};

const ViewportProvider = ({
  children,
  reqViewport,
}: ViewportProps): JSX.Element => {
  const initialViewport = reqViewport || Viewport.WIDE;
  const [viewport, setViewport] = useState(initialViewport);

  const setCurrentViewport = useCallback(
    (currentViewport: Viewport) => {
      if (viewport !== currentViewport) {
        setViewport(currentViewport);
      }
    },
    [viewport]
  );

  useEffect(() => {
    const initialViewportCS = getDeviceConfig(window.innerWidth);
    setCurrentViewport(initialViewportCS);

    const calcInnerWidth = () => {
      const newViewport = getDeviceConfig(window.innerWidth);
      setCurrentViewport(newViewport);
    };

    window.addEventListener('resize', calcInnerWidth);

    return () => {
      window.removeEventListener('resize', calcInnerWidth);
    };
  }, [setCurrentViewport]);

  return (
    <ViewportContext.Provider value={viewport}>
      {children}
    </ViewportContext.Provider>
  );
};

export default ViewportProvider;
